import { useGenders } from 'api/publicApi';
import { StyledSelect } from 'styles/overrides';
import _ from 'lodash';
import { filterOptions } from 'utils/formatUtils';

export default function GenderSelector({ onChange, value, ...restProps }) {
  const { data = [], isLoading } = useGenders({
    options: {
      select: (response) =>
        _.map(response, ({ code, name }) => ({
          label: name,
          value: code.toString(),
        })) ?? [],
    },
  });

  return (
    <StyledSelect
      options={data}
      loading={isLoading}
      showSearch
      optionFilterProp="name"
      filterOption={filterOptions}
      {...restProps}
      onChange={onChange}
      value={value}
    />
  );
}
